import type { Orientation } from '@/types/index';

interface OrientationCopiesRowProps {
  orientation: Orientation;
  copies: number;
  onOrientationChange: (value: Orientation) => void;
  onCopiesChange: (value: number) => void;
}

const MIN_COPIES = 1;
const MAX_COPIES = 99;

export function OrientationCopiesRow({
  orientation,
  copies,
  onOrientationChange,
  onCopiesChange,
}: OrientationCopiesRowProps) {
  return (
    <div className="row row-cols-1 row-cols-md-2 g-3">
      <div className="col">
        <div className="bg-surface-lowest rounded-4 shadow-kiosk-sm p-3 p-lg-4 h-100 d-flex flex-column justify-content-between">
          <div>
            <span className="text-label-md text-on-surface fw-bold d-block mb-1">Page orientation</span>
            <p className="text-body-sm text-on-surface-variant mb-3 d-none d-lg-block">
              Select page layout fed to hardware feed
            </p>
          </div>
          <div className="d-flex gap-1 p-1 bg-surface-low rounded-3">
            <button
              type="button"
              className={`btn flex-grow-1 border-0 d-flex flex-column align-items-center gap-1 py-2 ${
                orientation === 'portrait' ? 'bg-surface-high text-primary shadow-sm' : 'text-on-surface-variant'
              }`}
              onClick={() => onOrientationChange('portrait')}
            >
              <i className="bi bi-file-earmark" style={{ fontSize: 20 }} />
              <span className="text-label-sm">Portrait</span>
            </button>
            <button
              type="button"
              className={`btn flex-grow-1 border-0 d-flex flex-column align-items-center gap-1 py-2 ${
                orientation === 'landscape' ? 'bg-surface-high text-primary shadow-sm' : 'text-on-surface-variant'
              }`}
              onClick={() => onOrientationChange('landscape')}
            >
              <i className="bi bi-file-earmark" style={{ fontSize: 20, transform: 'rotate(90deg)' }} />
              <span className="text-label-sm">Landscape</span>
            </button>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="bg-surface-lowest rounded-4 shadow-kiosk-sm p-3 p-lg-4 h-100 d-flex flex-column justify-content-between">
          <div className="d-flex align-items-center justify-content-between mb-1 mb-lg-0">
            <span className="text-label-md text-on-surface fw-bold">Number of copies</span>
            <span className="text-label-sm text-primary fw-semibold d-lg-none">
              {copies} {copies === 1 ? 'Set' : 'Sets'}
            </span>
          </div>
          <p className="text-body-sm text-on-surface-variant mb-3 d-none d-lg-block">
            Collation will bundle each complete set
          </p>
          <div className="d-flex align-items-center justify-content-between bg-surface-low rounded-3 p-1">
            <button
              type="button"
              className="btn bg-surface-lowest shadow-sm rounded-3 tap-target active-press border-0"
              onClick={() => onCopiesChange(Math.max(MIN_COPIES, copies - 1))}
            >
              <i className="bi bi-dash-lg" />
            </button>
            <div className="d-flex flex-column align-items-center">
              <span className="text-headline-sm text-on-surface fw-bold">{copies}</span>
              <span className="text-label-sm text-on-surface-variant">
                {copies === 1 ? 'Copy' : 'Copies'}
              </span>
            </div>
            <button
              type="button"
              className="btn bg-surface-lowest shadow-sm rounded-3 tap-target active-press border-0"
              onClick={() => onCopiesChange(Math.min(MAX_COPIES, copies + 1))}
            >
              <i className="bi bi-plus-lg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
